import { Tabs } from "@marginly/ui/components/tabs";
import { Active, Disabled } from "@marginly/ui/constants/classnames";
import cn from "classnames";
import { t } from "ttag";
import * as S from "./styled";
import type { PositionDirection } from "../../state";

export function TradeTabs({
  disableShort,
  direction,
  onChange,
}: {
  disableShort?: boolean;
  direction?: PositionDirection;
  onChange?: (args: { direction?: PositionDirection }) => void;
}) {
  return (
    <Tabs className="tabs--longshort">
      <S.TabItem
        className={cn({ [Active]: direction === "long" })}
        onClick={() => {
          onChange?.({ direction: "long" });
        }}
      >
        {t`Long`}
      </S.TabItem>
      <S.TabItem
        className={cn({
          [Active]: direction === "short",
          disabled: disableShort,
        })}
        onClick={() => onChange?.({ direction: "short" })}
      >
        {t`Short`}
      </S.TabItem>
    </Tabs>
  );
}
